'use client';

import { ToggleButton } from '@mui/material';

import { styled } from '../../styles';
import { Theme } from '../../theme';

import { ToggleButtonProps } from './types';

const paddingBySize = ({
  size,
  theme,
}: ToggleButtonProps & { theme: Theme }) => {
  switch (size) {
    case 'medium':
      return theme.spacing(3, 4);
    case 'small':
      return theme.spacing(2, 4);
    default:
      return theme.spacing(1, 2);
  }
};

export const StyledToggleButton = styled(ToggleButton)<ToggleButtonProps>(
  (props) => ({
    padding: paddingBySize(props),
  }),
);
